export function isStatusChange(change) {
    return 'type' in change && change.type === 'status_change';
}
